import { useNavigate } from 'react-router-dom';

import { Grid } from '@mui/material';

import PageCard from '@/components/PageCard';
import { VEHICLE_PAGES } from '@/constants/vehicle-pages';

export default function Vehicles() {
  const navigate = useNavigate();

  return (
    <Grid
      container
      spacing={2}
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      {VEHICLE_PAGES.menuItems.map(
        ({ icon: Icon, path, title, showOnNavMenus }) => {
          if (showOnNavMenus !== undefined && !showOnNavMenus) {
            return null;
          }
          return (
            <Grid key={path} item onClick={() => navigate(path)}>
              <PageCard path={path} title={title} CardIcon={Icon} />
            </Grid>
          );
        }
      )}
    </Grid>
  );
}
